var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"skeleton-wrapper"},_vm._l((20),function(n){return _c('div',{key:n,staticClass:"skeleton skeleton-text"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }